<template lang="pug">
  .cart-link
    base-button.button--icon(
      @click="$store.dispatch('cart/openSidecart')"
    )
      span(:class="{ 'u-sr-only' : !hideIcon }") Cart
      icon(
        v-if="!hideIcon"
        name="cart"
        class="button__icon"
      )

    span.cart-link__quantity(v-if="numCartItems > 0")
      span.cart-link__count {{ numCartItems }}
</template>

<script>
  import { mapState } from 'vuex';
  import Icon from 'scripts/components/basic/Icon.vue';
  import BaseButton from 'scripts/components/buttons/BaseButton.vue';

  export default {
    name: 'CartLink',
    components: {
      Icon,
      BaseButton,
    },
    props: {
      hideIcon: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState({
        checkout: (state) => state.cart,
      }),
      numCartItems() {
        if (this.checkout) {
          return this.checkout.item_count || 0;
        }
        return 0;
      },
      cartIcon() {
        return this.numCartItems > 0 ? 'cart-full' : 'cart';
      },
    },
  };
</script>
